import { render, staticRenderFns } from "./ProvidersStore.vue?vue&type=template&id=74596bc1&"
import script from "./ProvidersStore.vue?vue&type=script&lang=js&"
export * from "./ProvidersStore.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports